<template>
<!-- eslint-disable max-len -->
  <div class="decision-result">
    <p>Decision result</p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    player: { type: Object, required: true }
  },
  computed: {
    ...mapGetters([
    ])
  }
};
</script>

<style lang="scss" scoped>
.decision-result {
  width: 100%;
  height: 100%;
  background: var(--primaryColor);
  border-radius: 2px;
}

p {
  font-size: 20px;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/game/ui/DecisionResult.vue